import { Component, forwardRef, Input, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { ControlContainer, ControlValueAccessor, DefaultValueAccessor, FormGroup, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HappyInputBase } from '../happy-template-input/happy-input-base';

export const RADIO_INPUT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HappyRadioInputComponent),
    multi: true,
};

@Component({
    selector: 'happy-radio-input',
    templateUrl: './happy-radio-input.component.html',
    styleUrls: ['./happy-radio-input.component.css', '../styles.css'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [RADIO_INPUT_VALUE_ACCESSOR]
})
export class HappyRadioInputComponent extends HappyInputBase {

    @Input() items: Array<{ key: string, value: string }>;
    @Input() disabledItems: any = {};
    @Input() multi = false;
    @Input() small = false;

    form: FormGroup;
    disabled = false;

    private value: string;
    // In case multi = true
    private values = [];
    private valuesSet = {};
    private changeFn: (value) => {};
    private touchFn: () => {};

    constructor(parentForm: FormGroupDirective) {
        super(parentForm);
    }

    ngOnInit() {
        this.form = this.parentForm.form;
    }

    writeValue(obj: any) {
        this.multi ?
            this.values = [...(obj || [])] :
            this.value = obj;
    }

    registerOnChange(fn: any) {
        this.changeFn = fn;
    }

    registerOnTouched(fn: any) {
        this.touchFn = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    isChecked(key: string) {
        return this.values.indexOf(key) > -1;
    }

    onSelect(e: MouseEvent, key: string) {
        // This is to stop the default bootstrap toggle behavior
        e.preventDefault();
        e.stopPropagation();
        if (this.disabled) {
            return;
        }

        this.touchFn();
        if (!this.multi) {
            this.value = key;
            this.changeFn(key);
        } else {
            const pos = this.values.indexOf(key);
            if (pos > -1) {
                this.values.splice(pos, 1);
            } else {
                this.values.push(key);
            }

            this.changeFn([...this.values]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-radio-input/happy-radio-input.component.ts